var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.507C25 12.2984 24.9141 12.0992 24.7711 11.9492L17.0375 4.1375C16.732 3.82891 16.2375 3.82969 15.9328 4.1375C15.6273 4.44531 15.6273 4.94531 15.9328 5.25313L22.3336 11.718H0.78125C0.35 11.718 0 12.0711 0 12.507C0 12.943 0.35 13.2961 0.78125 13.2961H22.3328L15.9328 19.7609C15.6273 20.0688 15.6281 20.5688 15.9328 20.8766C16.2383 21.1844 16.7328 21.1844 17.0375 20.8766L24.7711 13.0648C24.9172 12.9172 24.9977 12.7141 25 12.507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.50d85fa56450f62b0b118fda2d383f0f.svg";
export { ForwardRef as ReactComponent };